import { Building2, ChevronRight } from 'lucide-react'
import {
  GESTOR_TABLE_TH_CLASS,
  GESTOR_TABLE_TR_CLASS,
  GestorListTableShell,
  GestorTableAvatar,
} from '@/components/Gestores/GestorListTableShell'
import type { GestorClienteRow } from '@/services/gestoresService'

type Props = {
  clientes: GestorClienteRow[]
  loading?: boolean
  onSelect: (id: string) => void
}

export function GestorClientesTable({ clientes, loading, onSelect }: Props) {
  return (
    <GestorListTableShell
      loading={loading}
      loadingMessage='Carregando clientes…'
      empty={!loading && clientes.length === 0}
      emptyIcon={
        <Building2 size={48} className='mx-auto mb-3 text-[var(--text-muted)] opacity-50' />
      }
      emptyTitle='Nenhum cliente encontrado'
      emptyHint='Ajuste a busca ou aguarde novos clientes no seu setor'
    >
      <table className='w-full'>
        <thead>
          <tr className='border-b border-[var(--glass-border)]'>
            {['Cliente', 'CNPJ', 'Projetos', 'Deals', ''].map((h) => (
              <th
                key={h || 'actions'}
                className={GESTOR_TABLE_TH_CLASS}
                style={{ fontSize: 'var(--font-size-label)' }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {clientes.map((cliente) => (
            <tr
              key={cliente.id}
              className={GESTOR_TABLE_TR_CLASS}
              onClick={() => onSelect(cliente.id)}
            >
              <td className='px-4 py-3'>
                <div className='flex items-center gap-3'>
                  <GestorTableAvatar name={cliente.nome} />
                  <span
                    className='font-medium text-[var(--font-color-body)]'
                    style={{ fontSize: 'var(--font-size-sm)' }}
                  >
                    {cliente.nome}
                  </span>
                </div>
              </td>
              <td className='px-4 py-3'>
                <span
                  className='font-mono text-[var(--font-color-muted)]'
                  style={{ fontSize: 'var(--font-size-sm)' }}
                >
                  {cliente.cnpj ?? '—'}
                </span>
              </td>
              <td className='px-4 py-3'>
                {cliente._count.financeProjects > 0 ? (
                  <span className='rounded-md border border-[var(--brand-primary)]/20 bg-[var(--brand-primary)]/10 px-2 py-0.5 text-[9px] font-bold uppercase text-[var(--brand-primary)]'>
                    {cliente._count.financeProjects} Projeto
                    {cliente._count.financeProjects !== 1 ? 's' : ''}
                  </span>
                ) : (
                  <span
                    className='text-[var(--font-color-muted)]'
                    style={{ fontSize: 'var(--font-size-sm)' }}
                  >
                    —
                  </span>
                )}
              </td>
              <td className='px-4 py-3'>
                {cliente._count.deals > 0 ? (
                  <span className='rounded-md border border-emerald-500/20 bg-emerald-500/10 px-2 py-0.5 text-[9px] font-bold uppercase text-emerald-400'>
                    {cliente._count.deals} Deal{cliente._count.deals !== 1 ? 's' : ''}
                  </span>
                ) : (
                  <span
                    className='text-[var(--font-color-muted)]'
                    style={{ fontSize: 'var(--font-size-sm)' }}
                  >
                    —
                  </span>
                )}
              </td>
              <td className='px-4 py-3'>
                <ChevronRight size={14} className='text-[var(--text-muted)]' aria-hidden />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </GestorListTableShell>
  )
}
